import React from 'react'
import { Avatar, ButtonBase } from '@mui/material';

const UserIconButton = ({ avatar, name, handleClick }) => {
  return (
    <ButtonBase onClick={handleClick}>
      <Avatar
        alt={name}
        variant="rounded"
        src={avatar || undefined}
        sx={{
          backgroundColor: 'primary.main',
          textTransform: 'uppercase',
        }}
      >
        {name?.[0]}
      </Avatar>
    </ButtonBase>
  )
}

export default UserIconButton
